import { createStore } from 'vuex'

const store = createStore({
  state: {
    user: null,
    isSignIn: false,
    stationdata: null,
    vehicledata: null,
    todaystationdata: null,
    todaystationdatalength: null,
    stationdatarefreshtime: null,
    stationdataindex:null
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setUserSignInStatus(state, status) {
      state.isSignIn = status
    },
    setStationData(state, stationdata) {
      state.stationdata = stationdata
    },
    setVehicleData(state, vehicledata) {
      state.vehicledata = vehicledata
    },
    setTodayStationData(state, todaystationdata) {
      state.todaystationdata = todaystationdata
    },
    setTodayStationDataLength(state, todaystationdatalength) {
      state.todaystationdatalength = todaystationdatalength
    },
    setStationDataRefreshTime(state, time) {
      state.stationdatarefreshtime = time
    },
    setStationDataIndex(state, list) {
      state.stationdataindex = list
    },
  },
  getters: {
    isSignIn: (state) => {
      return state.isSignIn || state.user !== null
    },
    user:(state) => {
      return state.user
    },
    userAttributes:(state) => {
      return state.user ? state.user.attributes : null
    },
    userName:(state) => {
      return state.user ? state.user.username : null
    },
    stationData:(state) => {
      return state.stationdata || { stStatus: [] }
    },
    vehicleData:(state) => {
      return state.vehicledata || { vehicleStatus: [] }
    },
    todayStationData:(state) => {
      return state.todaystationdata || []
    },
    todayStationDataLength:(state) => {
      return state.todaystationdatalength || 0
    },
    todayStationDataRefreshTime:(state) => {
      return state.stationdatarefreshtime
    },
    stationDataIndex:(state) => {
      return state.stationdataindex
    }
  },
  actions: {},
  modules: {}
});

export default store
